module.exports = __webpack_public_path__ + "img/134.239b71be.png";